





























import Vue from "vue";

import ttIcon from "@joyz/app-core/assets/logo/terratalk-icon-fullcolor.svg";
import ttLogo from "@joyz/app-core/assets/logo/terratalk-logo-fullcolor.svg";

import iconChartSelected from "@joyz/app-core/assets/icons/default/Chart.svg";
import iconHomeSelected from "@joyz/app-core/assets/icons/default/Home.svg";
import iconMagnifyingGlassSelected from "@joyz/app-core/assets/icons/default/MagnifyingGlass.svg";
import iconStarSelected from "@joyz/app-core/assets/icons/default/Star.svg";

import iconChart from "@joyz/app-core/assets/icons/transparent/Chart.svg";
import iconHome from "@joyz/app-core/assets/icons/transparent/Home.svg";
import iconMagnifyingGlass from "@joyz/app-core/assets/icons/transparent/MagnifyingGlass.svg";
import iconStar from "@joyz/app-core/assets/icons/transparent/Star.svg";

import iconUserAvatar from "@tt-app/assets/icons/default/UserAvatar.png";
import { ROUTES } from "@tt-app/constants";
import NavBarLink from "./NavBarLink.vue";
import {
  LimitedModeDetails,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

interface NavRoute {
  name: string;
  hoverIcon?: string;
  i18nKey: string;
  cssClasses?: string;
  icons: {
    default: string;
    selected?: string;
  };
}

interface Data {
  isOpened: boolean;
  ttLogo: string;
  ttIcon: string;
}

interface Methods {
  toggleNavMenu: () => void;
}

interface Computed {
  currentRouteName: string;
  limitedModeDetails: LimitedModeDetails;
  navRoutes: NavRoute[];
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: "NavBar",
  components: { NavBarLink },

  data() {
    return {
      isOpened: false,
      ttLogo,
      ttIcon
    };
  },

  computed: {
    currentRouteName() {
      return this.$route.name || "";
    },

    limitedModeDetails() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.LIMITED_MODE_DETAILS}`
      ];
    },

    navRoutes() {
      if (this.limitedModeDetails) {
        return [
          {
            name: ROUTES.TERRATALK_LIVE.LOBBY.NAME,
            hoverIcon: iconHomeSelected,
            i18nKey: "nav.home",
            icons: {
              default: iconHome,
              selected: iconHomeSelected
            }
          },
          {
            name: ROUTES.USER.SETTINGS.NAME,
            i18nKey: "nav.settings",
            cssClasses: "user-settings-link ",
            icons: {
              default: iconUserAvatar
            }
          }
        ];
      }

      return [
        {
          name: ROUTES.HOME.NAME,
          hoverIcon: iconHomeSelected,
          i18nKey: "nav.home",
          icons: {
            default: iconHome,
            selected: iconHomeSelected
          }
        },
        {
          name: ROUTES.COURSE.EXPLORE.NAME,
          hoverIcon: iconMagnifyingGlassSelected,
          i18nKey: "nav.search",
          icons: {
            default: iconMagnifyingGlass,
            selected: iconMagnifyingGlassSelected
          }
        },
        {
          name: ROUTES.LEARNING_HISTORY.SUMMARY.NAME,
          i18nKey: "nav.learning-history",
          hoverIcon: iconChartSelected,
          icons: {
            default: iconChart,
            selected: iconChartSelected
          }
        },
        {
          name: ROUTES.SKILLS.OVERVIEW.NAME,
          i18nKey: "nav.skills",
          hoverIcon: iconStarSelected,
          icons: {
            default: iconStar,
            selected: iconStarSelected
          }
        },
        {
          name: ROUTES.USER.SETTINGS.NAME,
          i18nKey: "nav.settings",
          cssClasses: "user-settings-link ",
          icons: {
            default: iconUserAvatar
          }
        }
      ];
    }
  },

  methods: {
    toggleNavMenu() {
      this.isOpened = !this.isOpened;
    }
  }
});
